import React, { useContext, useEffect, useState } from "react";
import "../../Dashboard/View_List/View_List.css";

import Delete_Points_Modal from "../../Common_Component/Common_Modal/Delete_Points_Modal/Delete_Points_Modal";
import { Button, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  findAll,
  Delete,
  Status,
} from "../../../utils/apis/rummy/rummy_table_history/index";
import { Per_Page_Dropdown } from "../../../utils/common";
import Pagination_holder from "../../Common_Component/Pagination_holder/Pagination_holder";
import CustomPaginate from "../../Common_Component/CustomPaginate/CustomPaginate";
import { Context } from "../../../utils/context";
import Heading_Holder from "../../Common_Component/Heading_Holder/Heading_Holder";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";
import RummyRoundHistory from "../../Common_Component/Common_Modal/Rummy_Round_History/rummy_round_history";
import { useNavigate } from "react-router-dom";

const Tables = () => {
  const { UnauthorizedLogOut, IMG_URL, isAllow } = useContext(Context);
  const [rummyWalletHistory, setRummyWalletHistory] = useState([]);
  const [showRummyWalletHistory, setShowRummyWalletHistory] = useState(false);

  const [modalShow, setModalShow] = useState(false);
  const [modalEditShow, setModalEditShow] = useState(0);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(10);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();

  const getDataAll = async () => {
    try {
      const response = await findAll(currentPage, perPage, search);
      await setData(response?.data);
      setCurrentPage(response?.data?.data?.page);
      setperPage(response?.data?.data?.limit);

      setOption(await Per_Page_Dropdown(response?.data?.data?.totalPages));
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [
    search,
    changeStatus,
    perPage,
    reset,
    modalShow,
    modalEditShow,
    currentPage,
  ]);

  const StatusChange = async (id) => {
    const response = await Status(id);
    setChangeStatus(response);
  };

  const handleDeleteRecord = async () => {
    setModalDeleteShow(false);
    if (recordToDeleteId) {
      const response = await Delete(recordToDeleteId);

      await setShowModal({
        code: response.data.code,
        message: response.data.data,
      });

      setTimeout(() => {
        setShowModal(0);
      }, 2000);
      setRecordToDeleteId(null);
      setChangeStatus(response);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const navigate = useNavigate();

  return (
    <>
      <section className="View_List">
        <Heading_Holder headingText={"Rummy Table History"} />
        <div className="search-bar-holder ">
          <Form>
            <div className="row align-items-end">
              {/* <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5    ">
                <Form.Group className="form-field" controlId="formBasicEmail">
                  <br></br>
                  <Form.Control
                    type="text"
                    placeholder="Customer Name"
                    onChange={(e) => setSearch(e.target.value)}
                    value={search}
                    className="mt-1"
                  />
                </Form.Group>
              </div>{" "}
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5   col-holder">
                <br></br>
                <Button
                  type="button"
                  className="reset-btn mt-2"
                  onClick={() => {
                    setSearch("");
                    setReset(!reset);
                  }}>
                  Reset
                </Button>
              </div> */}
              {/* <div className=" col-12 mt-3">
                <div className="d-flex  align-items-center">
                  <div className="show me-2">
                    <p style={{ color: "white" }} className="show m-0">
                      Show
                    </p>
                  </div>
                  <div className="number me-2">
                    <select
                      className="form-select form-select-sm"
                      aria-label=".form-select-sm example"
                      onChange={(e) => setperPage(e.target.value)}
                    >
                      {option?.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="entries">
                    <p style={{ color: "white" }} className="show m-0">
                      entries
                    </p>
                  </div>

                  <div className="col-xxl-6 col-xl-6 col-lg-8 col-md-6 col-sm-2 col-12">
                    <div className="sowing me-2 ms-5">
                      <p
                        style={{ color: "white" }}
                        className="show m-0"
                      >{`Showing ${Math.min(
                        (currentPage - 1) * perPage + 1
                      )} to ${Math.min(
                        currentPage * perPage,
                        data?.data?.total
                      )} of ${data?.data?.total} entries`}</p>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </Form>
        </div>
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="user-list-table">
              {/* <Banner_List_Table /> */}

              <div className="data-table-holder">
                <Table responsive bordered striped>
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Room Id</th>
                      <th>Total Players</th>
                      <th>Playing Points</th>
                      <th>Playing Amount</th>
                      {/* <th>Total Playing Amount</th> */}
                      <th>Start Date</th>
                      <th>Start Time</th>
                      <th>End Date</th>
                      <th>End Time</th>
                      <th>Room Status</th>
                      <th>View</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data?.data?.data?.map((d, index) => {
                      return (
                        <tr>
                          <td>{(currentPage - 1) * perPage + index + 1}</td>
                          <td> {d?.room_id}</td>
                          <td>
                            {Math.max(
                              ...(d?.history?.map(
                                (c) => Number(c?.total_players) || 0,
                              ) || [0]),
                            )}
                          </td>
                          <td>
                            {d?.history?.[0]?.RummyRoom?.RummyPoint.name || "-"}
                          </td>
                          <td>
                            ₹{d?.history?.[0]?.RummyRoom?.RummyAmount?.amount}
                          </td>
                          {/* <td>
                            ₹{" "}
                            {d?.history?.[0]?.RummyRoom?.RummyAmount?.amount &&
                            d?.history?.[0]?.total_players
                              ? (
                                  Number(d.history[0].total_players) *
                                  Number(
                                    d.history[0].RummyRoom.RummyAmount.amount,
                                  )
                                ).toFixed(2)
                              : "-"}
                          </td> */}
                          <td>
                            {d?.history?.[0]?.createdAt
                              ? new Date(
                                  d.history[0].createdAt,
                                ).toLocaleDateString("en-GB")
                              : "-"}
                          </td>
                          <td>
                            {d?.history?.[0]?.createdAt
                              ? new Date(d.history[0].createdAt).toLocaleString(
                                  "en-GB",
                                  {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  },
                                )
                              : "-"}
                          </td>
                          <td>
                            {d?.history?.[0]?.updatedAt
                              ? new Date(
                                  d.history[0].updatedAt,
                                ).toLocaleDateString("en-GB")
                              : "-"}
                          </td>
                          <td>
                            {d?.history?.[0]?.updatedAt
                              ? new Date(d.history[0].updatedAt).toLocaleString(
                                  "en-GB",
                                  {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  },
                                )
                              : "-"}
                          </td>
                          <td>
                            <span
                              className={
                                d.history?.some(
                                  (item) => Number(item?.winning_amount) === 0,
                                )
                                  ? "rummy-status-running"
                                  : "rummy-status-completed"
                              }>
                              {d.history?.some(
                                (item) => Number(item?.winning_amount) === 0,
                              )
                                ? "Running"
                                : "Completed"}
                            </span>
                          </td>
                          <td>
                            <Button
                              onClick={() =>
                                navigate("/rummy-table-history-inner-page", {
                                  state: {
                                    room_id: d?.room_id,
                                    history: d?.history,
                                  },
                                })
                              }>
                              View
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <CustomPaginate
                  currentPage={data?.data?.page}
                  totalPages={data?.data?.totalPages}
                  handlePageChange={handlePageChange}
                />
                {/* <Heading_Holder subtext={"Note:"} /> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />

      <Delete_Points_Modal
        show={modalDeleteShow}
        handleDeleteRecord={handleDeleteRecord}
        onHide={() => setModalDeleteShow(false)}
      />

      <RummyRoundHistory
        onHide={() => setShowRummyWalletHistory(false)}
        show={showRummyWalletHistory}
        rummyWalletHistory={rummyWalletHistory}
      />
    </>
  );
};

export default Tables;
